import React, { createContext, useState } from "react"

export const CookiesContext = createContext()

const CookiesContextProvider = ({ children }) => {
  const [consentCookie, setConsentCookie] = useState("Initial state")
  const [darkModeCookie, setDarkModeCookie] = useState("Initial state")
  return (
    <CookiesContext.Provider
      value={{
        consentCookie,
        setConsentCookie,
        darkModeCookie,
        setDarkModeCookie,
      }}
    >
      {children}
    </CookiesContext.Provider>
  )
}

export default CookiesContextProvider
